import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BacnetDeviceService} from "../../../../services/bacnet-device.service";
import {BacnetDevice} from "../../../../domain/bacnet-device";

@Component({
  selector: 'eis-gateway-delete-bacnet-device-dialog',
  templateUrl: './delete-bacnet-device-dialog.component.html',
  styleUrls: ['./delete-bacnet-device-dialog.component.scss']
})
export class DeleteBacnetDeviceDialogComponent implements OnInit {

  // device: OPCUADevice;

  deleteDatapoints: boolean = false;
  device: BacnetDevice;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { gatewaySerial: string, device: BacnetDevice },
              public dialogRef: MatDialogRef<DeleteBacnetDeviceDialogComponent>,
              private bacnetDeviceService: BacnetDeviceService) {

  }

  ngOnInit(): void {
    this.device = this.data.device;
  }

  deleteDevice() {
    this.bacnetDeviceService.markDeviceAndDatapointsAsPendingDelete(this.device.id).subscribe((value:  any) => {
        this.dialogRef.close({success: true});
      },
      (error:any) => {
        this.dialogRef.close({success: false});
      });
  }


}
